export enum AuthenticationStatus {
  Unknown = 'Unknown',
  Authenticating = 'Authenticating',
  Authenticated = 'Authenticated',
  UnAuthenticated = 'UnAuthenticated',
  AuthenticationFailed = 'AuthenticationFailed',
}
